import BaseTextButton from './BaseTextButton';

export default BaseTextButton;